import { useState, type SyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/shared/auth/contexte';
import { Button, Champ, Chargement } from '@/shared/ui';
import { Alerte, CadreConnexion } from './CadreConnexion';

/**
 * Atteinte par le lien d'invitation ou de réinitialisation : Supabase a déjà
 * ouvert la session à partir de l'adresse, il reste à fixer le mot de passe.
 */
export function NouveauMotDePassePage() {
  const { etat, service } = useAuth();
  const navigate = useNavigate();
  const [motDePasse, setMotDePasse] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [erreurs, setErreurs] = useState<{
    motDePasse?: string | undefined;
    confirmation?: string | undefined;
  }>({});
  const [refus, setRefus] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  if (etat.statut === 'chargement') return <Chargement />;
  if (etat.statut === 'anonyme') {
    return (
      <CadreConnexion titre="Lien expiré" sousTitre="Ce lien n’ouvre plus de session.">
        <Alerte ton="danger">
          Le lien a expiré ou a déjà servi. Demandez-en un nouveau depuis « Mot de passe oublié ».
        </Alerte>
        <Button className="mt-4 w-full" onClick={() => void navigate('/mot-de-passe-oublie')}>
          Demander un nouveau lien
        </Button>
      </CadreConnexion>
    );
  }

  async function soumettre(evenement: SyntheticEvent) {
    evenement.preventDefault();
    const suivantes: typeof erreurs = {};
    if (motDePasse.length < 8) suivantes.motDePasse = '8 caractères au moins.';
    if (confirmation !== motDePasse) suivantes.confirmation = 'Les deux saisies diffèrent.';
    setErreurs(suivantes);
    if (Object.keys(suivantes).length > 0) return;

    setEnvoi(true);
    const resultat = await service.definirMotDePasse(motDePasse);
    setEnvoi(false);
    if (resultat.ok) void navigate('/', { replace: true });
    else setRefus(resultat.message);
  }

  return (
    <CadreConnexion
      titre="Nouveau mot de passe"
      sousTitre="Choisissez le mot de passe de votre compte."
    >
      <form noValidate onSubmit={(e) => void soumettre(e)} className="flex flex-col gap-4">
        <Champ
          libelle="Mot de passe"
          type="password"
          autoComplete="new-password"
          value={motDePasse}
          erreur={erreurs.motDePasse}
          onChange={(e) => {
            setMotDePasse(e.target.value);
            setErreurs((p) => ({ ...p, motDePasse: undefined }));
          }}
        />
        <Champ
          libelle="Confirmation"
          type="password"
          autoComplete="new-password"
          value={confirmation}
          erreur={erreurs.confirmation}
          onChange={(e) => {
            setConfirmation(e.target.value);
            setErreurs((p) => ({ ...p, confirmation: undefined }));
          }}
        />
        {refus ? <Alerte ton="danger">{refus}</Alerte> : null}
        <Button type="submit" variante="principal" disabled={envoi} className="h-11">
          Enregistrer et continuer
        </Button>
      </form>
    </CadreConnexion>
  );
}
